import React from "react";

interface PatientFormData {
  patientMobile: string;
  drName: string;
  patientAddress: string;
  patientName: string;
  patientPincode: string;
}

interface PatientDetailsCardProps {
  formData: PatientFormData;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => void;
}

const PatientDetailsCard: React.FC<PatientDetailsCardProps> = ({
  formData,
  handleInputChange,
}) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <h2 className="text-lg font-bold text-gray-800 mb-4">Patient Details</h2>
      <div className="grid grid-cols-3 gap-x-6 gap-y-4">
        {/* Row 1 */}
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Patient Mobile No.
          </label>
          <input
            type="tel"
            name="patientMobile"
            value={formData.patientMobile}
            onChange={handleInputChange}
            maxLength={10}
            placeholder="10-digit No."
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Doctor Name
          </label>
          <input
            type="text"
            name="drName"
            value={formData.drName}
            onChange={handleInputChange}
            placeholder="Dr Name"
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
          />
        </div>
        <div className="row-span-2">
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Patient Address
          </label>
          <textarea
            name="patientAddress"
            value={formData.patientAddress}
            onChange={handleInputChange}
            placeholder="Address"
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 resize-none"
          />
        </div>
        {/* Row 2 */}
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Patient Name
          </label>
          <input
            type="text"
            name="patientName"
            value={formData.patientName}
            onChange={handleInputChange}
            placeholder="Patient Name"
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Patient Pin code
          </label>
          <input
            type="text"
            name="patientPincode"
            value={formData.patientPincode}
            onChange={handleInputChange}
            maxLength={6}
            placeholder="Pincode"
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
          />
        </div>
      </div>
    </div>
  );
};

export default PatientDetailsCard;
